import { render } from "./CnRules.vue?vue&type=template&id=cae5fa88&scoped=true"
import script from "./CnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./CnRules.vue?vue&type=script&scoped=true&lang=js"

import "./CnRules.vue?vue&type=style&index=0&id=cae5fa88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cae5fa88"

export default script